"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SerializableError = void 0;
const tslib_1 = require("tslib");
const apigw_models_1 = require("@integration/apigw-models");
const class_transformer_1 = require("class-transformer");
const class_transformer_validator_1 = require("class-transformer-validator");
const class_validator_1 = require("class-validator");
const defaultTransformValidationOptions = {
    validator: {
        forbidUnknownValues: true,
    },
};
class SerializableError extends Error {
    toJSON() {
        return (0, class_transformer_1.instanceToPlain)({ ...this, message: this.message });
    }
    static fromJSON(src) {
        const transformed = (0, class_transformer_validator_1.transformAndValidateSync)(this, src, defaultTransformValidationOptions);
        if (Array.isArray(transformed)) {
            throw new Error('Expected a single instance from JSON string but got an array');
        }
        return transformed;
    }
    /**
     * fromPlain as the "normal" Serializable, but _with_ a validation step.
     */
    static fromPlain(src) {
        const transformed = (0, class_transformer_validator_1.transformAndValidateSync)(this, src, defaultTransformValidationOptions);
        return Object.assign(new this(), transformed);
    }
}
tslib_1.__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, apigw_models_1.Docs)({ example: 400, description: 'HTTP Status Code' }),
    tslib_1.__metadata("design:type", Number)
], SerializableError.prototype, "statusCode", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, apigw_models_1.Docs)({ example: 'bad_request', description: 'HTTP Status' }),
    tslib_1.__metadata("design:type", String)
], SerializableError.prototype, "code", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, apigw_models_1.Docs)({
        example: 'Request body cannot be parsed',
        description: 'Message describing the error.',
    }),
    tslib_1.__metadata("design:type", String)
], SerializableError.prototype, "message", void 0);
exports.SerializableError = SerializableError;
